import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { GetIconByName } from "../../../../config/icon";
import { closeHomeAdModal } from "../../../console/redux/actions";
import "./styles.scss";
import { getInsight } from "../../../../utils";

const Index = ({ onAdInfo }) => {
  const adUrl = process.env.REACT_APP_HOME_SIDE_CENTER_ADV; // should be your invoke.js URL
  const dispatch = useDispatch();
  const adContainerRef = useRef(null);

  const [countdown, setCountdown] = useState(10);
  const [showClose, setShowClose] = useState(false);
  const [insight_id, setInsightId] = useState(null);

  useEffect(() => {
    let isMounted = true; // To prevent setting state or calling refs if unmounted
    let insight_id = null;

    const setup = async () => {
      try {
        const insight = await getInsight();

        if (isMounted && insight && insight.insight_id) {
          insight_id = insight.insight_id;

          const iframe = adContainerRef.current;
          const sendInsight = () => {
            if (iframe?.contentWindow) {
              iframe.contentWindow.postMessage(
                { insight_id },
                process.env.REACT_APP_CATEGORY_RIGHT_TOP_ADV,
              );
            }
          };

          // Add listener only after insight is confirmed
          iframe?.addEventListener("load", sendInsight);

          // Cleanup
          return () => {
            iframe?.removeEventListener("load", sendInsight);
          };
        }
      } catch (err) {
        console.warn("Failed to get insight", err);
      }
    };

    setup();

    return () => {
      isMounted = false;
    };
  }, [adUrl]);

  useEffect(() => {
    const handleMessage = (event) => {
      // Only accept messages from THIS component's own iframe
      if (event.source !== adContainerRef.current?.contentWindow) {
        return;
      }

      if (event.data?.type === "AD_READY") {
        if (adContainerRef.current?.contentWindow && insight_id) {
          adContainerRef.current.contentWindow.postMessage(
            { type: "SET_INSIGHT_ID", insight_id },
            "*",
          );
        }
      }

      if (event.data?.type === "AD_INFO") {
        onAdInfo(event.data.payload);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [onAdInfo, insight_id]);

  const handleIframeLoad = () => {
    if (adContainerRef.current?.contentWindow && insight_id) {
      adContainerRef.current.contentWindow.postMessage(
        { type: "SET_INSIGHT_ID", insight_id },
        "*",
      );
    }
  };

  // countdown
  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown((c) => c - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      setShowClose(true);
    }
  }, [countdown]);

  const handleClose = () => {
    dispatch(closeHomeAdModal());
  };

  return (
    <div className="right-ad active" style={{ position: "relative" }}>
      {/* Timer / Close button */}
      <div
        style={{
          position: "absolute",
          top: "3px",
          left: "3px",
          background: "#ffffff",
          color: "#ff1010",
          fontWeight: "bold",
          padding: "8px",
          fontSize: "12px",
          zIndex: 10,
          cursor: showClose ? "pointer" : "default",
          border: "1px solid #c40b4a",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onClick={showClose ? handleClose : undefined}
      >
        {showClose ? (
          <span
            style={{ fontSize: "12px", color: "#ff1010", fontWeight: "bold" }}
          >
            {GetIconByName("cross", "#ff1010")}
          </span>
        ) : (
          `00:${countdown < 10 ? `0${countdown}` : countdown}`
        )}
      </div>
      {/* Ad container (script will render into this div) */}
      <div
        // ref={adContainerRef}
        style={{
          width: "100%",
          height: "auto",
          border: "none",
          display: "block",
        }}
      />
      <iframe
        ref={adContainerRef}
        title="Advertisement"
        src={adUrl}
        onLoad={handleIframeLoad}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          display: "block",
        }}
        loading="lazy"
        sandbox="allow-scripts allow-same-origin allow-popups" // Optional
      />
    </div>
  );
};

export default Index;
